import styled from "styled-components";
import theme from "../../styles/theme";

// Shared form/action primitives. These replace near-identical Button and Input
// definitions that were repeated in Login, Register, Profile, EditTopic,
// SubtopicEdit and Navbar and had drifted apart.

export const Button = styled.button`
  padding: 0 ${theme.space.lg};
  height: ${theme.control};
  border: none;
  border-radius: ${theme.radius.sm};
  cursor: pointer;
  font-family: inherit;
  font-size: ${theme.font.sm};
  font-weight: 500;
  /* Some of these render as router links; suppress the anchor underline. */
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) =>
    props.$secondary ? theme.color.borderSubtle : theme.color.accent};
  color: ${(props) => (props.$secondary ? theme.color.text : "#ffffff")};
  transition: background-color 0.15s;

  &:hover:not(:disabled) {
    background-color: ${(props) =>
      props.$secondary ? theme.color.border : theme.color.accentHover};
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.focus};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

export const IconButton = styled.button`
  width: ${theme.control};
  height: ${theme.control};
  flex: 0 0 auto;
  padding: 0;
  border: none;
  border-radius: ${theme.radius.sm};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.font.md};
  text-decoration: none;
  background: ${(props) =>
    props.$active
      ? theme.color.accent
      : props.$danger
      ? "transparent"
      : theme.color.borderSubtle};
  color: ${(props) =>
    props.$active
      ? "#ffffff"
      : props.$danger
      ? theme.color.danger
      : theme.color.text};
  transition: background-color 0.15s;

  &:hover {
    background: ${(props) =>
      props.$active
        ? theme.color.accentHover
        : props.$danger
        ? theme.color.dangerBg
        : theme.color.border};
  }

  &:focus-visible {
    outline: 2px solid ${theme.color.focus};
    outline-offset: 2px;
  }
`;

export const Input = styled.input`
  width: 100%;
  min-width: 0;
  padding: 0 ${theme.space.md};
  height: ${theme.control};
  border: 1px solid ${theme.color.border};
  border-radius: ${theme.radius.sm};
  background: ${theme.color.surface};
  color: ${theme.color.text};
  font-family: inherit;
  font-size: ${theme.font.md};

  &::placeholder {
    color: ${theme.color.textFaint};
  }

  &:focus {
    outline: 2px solid ${theme.color.focus};
    outline-offset: -1px;
    border-color: ${theme.color.focus};
  }
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${theme.space.xs};
  font-size: ${theme.font.sm};
  color: ${theme.color.textMuted};
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${theme.space.md};
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: ${theme.space.md};
  justify-content: flex-end;
`;

// Centered card used by the auth and profile screens.
export const Panel = styled.div`
  max-width: 380px;
  margin: ${theme.space.xl} auto;
  padding: ${theme.space.xl};
  background: ${theme.color.surface};
  border: 1px solid ${theme.color.borderSubtle};
  border-radius: ${theme.radius.md};
  box-shadow: ${theme.shadow.panel};

  h2 {
    margin-bottom: ${theme.space.lg};
    font-size: ${theme.font.xl};
    color: ${theme.color.text};
  }
`;
